module.exports = __webpack_public_path__ + "img/govpage_4.e6c3d107.svg";